// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__ZK-DJ","body":"Container_body__3gBId","history":"Container_history__1xqt9"};